import { useContext, createContext } from "react";

export const useImportContext = () => useContext(ImportContext);

const ImportContext = createContext({
  model: null,
  modeName: null,
  operation: null,
});

export default ImportContext;
